import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { topOffenderFilterInitialState } from "./initialState";

const topOffenderFilterSlice = createSlice({
  name: "topOffenderFilters",
  initialState: topOffenderFilterInitialState,
  reducers: {
    setSelectedRegion: (state, action: PayloadAction<string>) => {
      state.selectedRegion = action.payload;
    },
    setSelectedType: (state, action: PayloadAction<string>) => {
      state.selectedType = action.payload;
    },
    setSelectedStatus: (state, action: PayloadAction<string>) => {
      state.selectedStatus = action.payload;
    },
    setSelectedAlarmType: (state, action: PayloadAction<string>) => {
      state.selectedAlarmType = action.payload;
    },
    setSelectedConfigStatus: (state, action: PayloadAction<string>) => {
      state.selectedConfigStatus = action.payload;
    },
    resetTopOffenderFilters: () => topOffenderFilterInitialState,
  },
});

export const {
  setSelectedRegion,
  setSelectedType,
  setSelectedStatus,
  setSelectedAlarmType,
  setSelectedConfigStatus,
  resetTopOffenderFilters,
} = topOffenderFilterSlice.actions;

export const TopOffenderFilterReducer = topOffenderFilterSlice.reducer;
